// The APP's own strings — page and feature text only: page and chart titles, tooltips, empty
// states, the report's option titles and `Translation` block, file names, and the app-only
// drill-level `titleKey`s the chart configs pass to the base charts (raw keys; the base chart
// runs `t()` and resolves them through the root composer — SKILL.md rule 4).
// rdrive's shared words (nav and entity names, the item model, generic labels: `drawings`,
// `status`, `category`, `total`, …) are NOT here: they come from `@rdrive/vocabulary`, merged UNDER
// this bundle by `createDashboard` (@rdrive/plugin-dashboard-shell) as
// `mergeMessages(vocabulary, messages)` — both passed in `../dashboard.config.js`'s `i18n`
// (PLATFORM.md §6 decision 22). One home per key: never define a vocabulary key here — the app's
// copy would win silently; `pnpm i18n:extract` reports any such key under OVERRIDES. A packaged
// component's strings do NOT belong here either: they live in its own colocated `messages/`
// folder (SKILL.md rule 11, PLATFORM.md §6 decision 15). Same format as those folders and as
// project-overview's `src/locales/`: one JSON per locale + this barrel.
//
// Split from the old one-module `locales.js` in IA_ABSORPTION_PLAN Phase 4 step 14: its 39
// vocabulary copies and every key with no reader left (the old dialogs', cards', FAB's and
// project-overview leftovers) were dropped; every remaining value is unchanged.
//
// Adding a key means adding it to all 11 files (an untranslated key falls back to `en` through
// `fallbackLocale`). Adding a locale means `SUPPORTED_LOCALES` in `@rdrive/i18n` + a file here + a
// file in `@rdrive/vocabulary` + a file in every package `messages/` folder. `pnpm i18n:extract`
// reports the gaps for all of them (this bundle appears there as `issue-analysis/locales`).
//
// JSON carries no comments, so the notes live here:
// - Every file keeps the old module's `en` key order (`locations` and `reportGenerationFailed`,
//   the two keys added in step 14, sit beside their neighbours).
// - `issueCategory`/`issueType`/`issueItem`/`responsibleParty`/`singlestatus`/`priority`/
//   `locations`/`issueCategories`/`issueTypes`/`issueItems` are drill-level titles
//   (`navigationConfig[].titleKey` in `charts/configs/`); `drawingSets`/`drawings`/`status` are
//   vocabulary keys, resolved through the same root composer.
// - `filterDialog.overdueOnly` is the label of the FAB's "overdue only" extra toggle (App/setup.js's
//   `extraToggles`); the dialog's own chrome lives in @rdrive/plugin-status-filter.
// - The issues grid's own strings (its title, column titles, cell labels, photo dialog) left with
//   it on 2026-10-12, when it became `@rdrive/plugin-items-grid`'s IssuesGrid — ten keys deleted
//   here (`settings.close`, `issuesGrid`, `noPhoto`, `notSet`, `dueToday`, `daysOverdue`,
//   `daysLeft`, `lastUpdated`, `issueDetails`, `statusInfo`); `issueDescription`/
//   `responsibleParty`/`dueBy` stay (the report and the Analysis page read them; `photo`, read by
//   the report too, is `@rdrive/vocabulary`'s since AM_ABSORPTION_PLAN F4).
//   `issueStatusBreakdown` stays too: ProjectPage passes it as the package StatusBreakdownCard's title.
// - `rdriveBurndownChart` / `rdriveVelocityChart` are PNG export FILE NAMES (`.png` appended by
//   the pages), not UI text.
// - The report (composables/useIssuesGridReport.js) reads the `*Title`/`*Name` keys for its Group by /
//   Order by options and the `Translation` block, and `reportGenerationFailed` for its alert.
//
// Keep the imports plain: no `with { type: 'json' }` (Vite serves transformed JSON as JavaScript
// and the browser rejects the attribute). Node proof scripts need a `load` hook.
import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import it from './it.json';
import nl from './nl.json';
import pl from './pl.json';
import ptBR from './pt-BR.json';
import th from './th.json';
import vi from './vi.json';
import zhHans from './zh-Hans.json';
import zhHant from './zh-Hant.json';

export default {
  de,
  en,
  fr,
  it,
  nl,
  pl,
  'pt-BR': ptBR,
  th,
  vi,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
};
